import * as _ from 'lodash';
import * as moment from 'moment';
import { randomColor } from 'randomcolor';

export default {
    title: 'Class time consumption',
    chartSettings: {
        type: 'pie',
        options: {
            responsive: true,
            maintainAspectRatio:false,
            legend: {
                display: false
            },
            tooltips: {
                callbacks: {
                    title: function(tooltipItem, data, c) {
                        return "Class: " + data.labels[tooltipItem[0].index];
                    },
                    label: function(tooltipItem, data, c) {
                        let tt = tooltipItem;
                        let value = data.datasets[tt.datasetIndex].data[tt.index];
                        return "Time consumed: " + moment.unix(value).utc().format("HH:mm:ss")
                    }
                }
            }
        },
        data: {
            backgroundColor: 'red'
        }
    },
    mapData(data){
        return {
            labels: _.map(data, 'class_name'),
            datasets: [{
                backgroundColor: _.map(data, () => randomColor()),
                data: _.map(data, 'duration')
            }]
        }
    },
    fetchDataFn: 'getTimeConsumingByClass'

}


// WEBPACK FOOTER //
// ./src/components/stats/charts/commonWidgetSettings/classTimeConsumption.settings.js